import type { MailboxInfo } from "owa-client-types";
import { getAliasDisplayNames } from "owa-nonboot-userconfiguration-manager";

export function getDisplayNameOfAddress(email: string, mailboxInfo: MailboxInfo): string | undefined {
    const aliasDisplayNamesList = getAliasDisplayNames(mailboxInfo);
    const itemFound = aliasDisplayNamesList.find(entry => entry.Alias?.toLowerCase() == email.toLowerCase());
    return (itemFound && itemFound.DisplayName) || undefined;
}

export function getAliasDisplayNameString(email?: string, displayName?: string): string | undefined {
    return email && displayName ? displayName + " <" + email + ">" : email;
}
